import React, { forwardRef, useMemo } from 'react'

import {
  ControllerFieldState,
  ControllerRenderProps,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  UseFormStateReturn,
} from 'react-hook-form'

import { parseComponentConfig } from '../../utils/parseComponentConfig'
import { IOcField, IOcFieldError } from '../../utils/types'
import { formComponentMap } from './formComponentMap'

interface Props {
  formControllerRenderProps: {
    field: ControllerRenderProps<FieldValues, string>
    fieldState: ControllerFieldState
    formState: UseFormStateReturn<FieldValues>
  }
  formValidationError?:
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<any>>
    | undefined
  ocFieldError?: IOcFieldError
  ocField: IOcField
}

const FormComponent: React.FC<Props> = forwardRef((props, ref) => {
  const {
    formControllerRenderProps: { field },
    formValidationError,
    ocFieldError,
    ocField,
  } = props

  // TODO: Error message

  const componentConfig = formComponentMap[ocField?.type]

  const { Component, componentProps } = useMemo(
    () =>
      parseComponentConfig({
        config: componentConfig,
        field,
        ocField,
      }),
    [field, componentConfig]
  )

  if (!componentConfig) {
    return null
  }

  return (
    <Component
      {...componentProps}
      value={field.value}
      ref={ref}
      errorMessage={ocFieldError?.message ?? formValidationError?.message}
    />
  )
})

export default FormComponent
